var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ClickAwayListener } from "@mui/material";
import { Download, X } from "@piiqtechnologies/svg-icons";
import { PeekButton, PeekIconButton, PeekPaper, PeekStack, PeekTab, PeekTabs, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
import { useAnalytics, useDownloadAnalyticsReports, useNotification, } from "@piiqtechnologies/ui-lib";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import DownloadAnalyticsForm from "./DownloadAnalyticsForm";
import DownloadAnalyticsProgress from "./DownloadAnalyticsProgress";
import messages from "./messages.i18n";
import { format } from "date-fns";
const DownloadCsvButton = ({ period, communityIds, height, width }) => {
    const intl = useIntl();
    const { setNotification } = useNotification();
    const analytics = useAnalytics();
    const theme = useTheme();
    const [showDialog, setShowDialog] = useState(false);
    const [downloadAnalyticsData, finishedReports] = useDownloadAnalyticsReports();
    const [activeTab, setActiveTab] = useState("settings");
    const [selectedReports, setSelectedReports] = useState([]);
    /**
     * Handle Download Csv
     * @param values
     * @description This function is called when the user clicks on the download button
     * It prepares the payload and calls the download analytics api to download the csv asynchronously
     * */
    const handleDownloadCsv = (values) => {
        const { communities, dateRange } = values, options = __rest(values, ["communities", "dateRange"]);
        const payload = {
            communityIds: communities,
            startDate: format(new Date(dateRange.startDate.toString()), "yyyy-MM-dd"),
            endDate: format(new Date(dateRange.endDate.toString()), "yyyy-MM-dd"),
            options,
        };
        setSelectedReports(Object.keys(options).filter((key) => options[key]));
        setActiveTab("in_progress");
        downloadAnalyticsData(payload);
        analytics.track("Download Analytics data");
        setNotification(intl.formatMessage(messages.downloadAnalyticslert));
    };
    /**
     * Handle download click
     * Toggles the Dowload form dialog
     */
    const handleDownloadClick = (values) => {
        setShowDialog(!showDialog);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekButton, { size: "large", onClick: handleDownloadClick, sx: {
                height: height,
                width: width,
                minWidth: "fit-content",
                whiteSpace: "nowrap",
            }, startIcon: React.createElement(Download, { width: 12 }), variant: "outlined", color: "info", "data-testid": "download-csv-button" }, intl.formatMessage(messages.downloadCsvTitle)),
        showDialog && (React.createElement(ClickAwayListener, { onClickAway: () => setShowDialog(false) },
            React.createElement(PeekPaper, { sx: {
                    position: "absolute !important",
                    top: 156,
                    marginLeft: `-${theme.spacing(3)} !important`,
                    zIndex: 10,
                    width: "515px",
                } },
                React.createElement(PeekIconButton, { onClick: () => setShowDialog(false), bordered: false, sx: { position: "absolute", right: 5, top: 5 } },
                    React.createElement(X, { width: 20, height: 20 })),
                React.createElement(PeekStack, { spacing: 2 },
                    React.createElement(PeekTypography, { variant: "h3", mt: 2, ml: 2 }, intl.formatMessage(messages.downloadCsvTitle)),
                    React.createElement(PeekTabs, { value: activeTab, orientation: "horizontal", onChange: (_, value) => setActiveTab(value) },
                        React.createElement(PeekTab, { id: "settings", label: "Settings", value: "settings" }),
                        React.createElement(PeekTab, { disabled: true, id: "settings", label: "In Progress", value: "in_progress" })),
                    activeTab === "settings" && (React.createElement(DownloadAnalyticsForm, { period: period, communityIds: communityIds, onDownload: handleDownloadCsv })),
                    activeTab === "in_progress" && (React.createElement(DownloadAnalyticsProgress, { selectedReports: selectedReports, finishedReports: finishedReports }))))))));
};
export default DownloadCsvButton;
